export const GQL_SUBMIT_REVIEW = `
    mutation SubmitReview(
        $authorId: String!,
        $authorName: String!,
        $body: String!,
        $itemId: String!,
        $rating: Int!
    ) {
        submitReview (
            authorId: $authorId,
            authorName: $authorName,
            body: $body,
            itemId: $itemId,
            rating: $rating
        )
    }
`;
